import { Alert, styled } from "@mui/material"

/**
 * Custom alert component for the application. All alerts should be
 * displayed using this component. The component is styled to match
 * the application theme.
 */
const AppAlert = styled(Alert)(({ theme, severity }) => {
    const severityBgColorMap = {
        error: theme.palette.error.light,
        warning: theme.palette.warning.light,
        info: theme.palette.primary.light,
        success: theme.palette.success.light,
    }
    const severityTextColorMap = {
        error: theme.palette.error.dark,
        warning: theme.palette.warning.dark,
        info: theme.palette.primary.dark,
        success: theme.palette.success.dark,
    }

    return {
        borderRadius: theme.spacing(1),
        backgroundColor: severityBgColorMap[severity ?? "info"],
        color: severityTextColorMap[severity ?? "info"],
        "& *": {
            color: severityTextColorMap[severity ?? "info"],
        },
    }
})

export default AppAlert
